import { Button, Icon_CheckmarkFilled60 } from "@shapr3d/frontend-lib";

import { Modal } from "../../lib/modal";

import style from "./TwoFactorEnabledModal.module.css";

export type TwoFactorEnabledModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function TwoFactorEnabledModal({ open, onClose }: TwoFactorEnabledModalProps) {
  return (
    <Modal
      open={open}
      telemetryName="two_factor_setup_success"
      onClose={onClose}
      size="medium"
      title="2FA enabled"
      persistent
      footer={
        <div className={style.footer}>
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      }
    >
      <div className={style.container}>
        <Icon_CheckmarkFilled60 className={style.icon} />

        <div className={style.content}>
          <p className={style.description}>
            Your account is now protected with two-factor authentication. You&apos;ll be asked to
            enter a verification code each time you sign in.
          </p>
        </div>
      </div>
    </Modal>
  );
}
